module.exports = __webpack_public_path__ + "static/media/1.86b52918.jpg";